import React, { FC } from 'react';
import { observer } from 'mobx-react';
import ResponseEntity from '../../../../store/polls-store/response-entity';
import ProgressBar from '../../../shared/progress-bar/progress-bar';

interface IProps {
  response: ResponseEntity;
  percent: number;
  shouldHideVotesCount?: boolean;
}

const PollResponseVotes: FC<IProps> = ({ response, percent, shouldHideVotesCount }) => {
  return (
    <div className='poll-response-vote'>
      <div className='poll-response-vote-choice'>{response.value}</div>
      {!shouldHideVotesCount && <div className='poll-response-vote-votes'>{response.count} Votes</div>}
      <ProgressBar percents={percent}/>
    </div>
  );
};

export default observer(PollResponseVotes);